import request from '@/utils/request'
export function addProduct(data) {
    return request({
        url: `api/serviceCenter/product/addProduct`,
        method: 'post',
        data,
    })
}

export function upDateProduct(data) {
    return request({
        url: `api/serviceCenter/product/upDateProduct`,
        method: 'post',
        data,
    })
}

export function productSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/product/productSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function bathDeleteProduct(data) {
    return request({
        url: `api/serviceCenter/product/bathDeleteProduct`,
        method: 'post',
        data,
    })
}


export function selectProductCategory(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/product/selectProductCategory`,
        method: 'post',
        data,
    })
}

